import Grid from '@mui/material/Grid';

import type { DinerFieldProps } from 'reservations/availabilities/types';
import { CreateFields } from 'reservations/form/components/CreateFields';
import FinePrint from 'reservations/form/components/FinePrint';
import MarketingOptIn from 'reservations/form/components/MarketingOptIn';
import { ModifyFields } from 'reservations/form/components/ModifyFields';
import { WaitlistFields } from 'reservations/form/components/WaitlistFields';
import { useBookingForm } from 'reservations/form/providers/BookingFormProvider';

export const DinerInputFields = ({
  handleFormDrawerClose
}: DinerFieldProps) => {
  const { isModify, isWaitlist } = useBookingForm();

  const DinerFields = () => {
    switch (true) {
      case isModify:
        return <ModifyFields handleFormDrawerClose={handleFormDrawerClose} />;
      case isWaitlist:
        return <WaitlistFields handleFormDrawerClose={handleFormDrawerClose} />;
      default:
        return <CreateFields handleFormDrawerClose={handleFormDrawerClose} />;
    }
  };

  return (
    <>
      <DinerFields />
      <Grid item sx={{ mt: '-10px' }}>
        <FinePrint />
      </Grid>
      {!isModify && (
        <Grid item>
          <MarketingOptIn />
        </Grid>
      )}
    </>
  );
};
